'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SearchResultAddButton = require('./components/SearchResultAddButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SearchResultAddButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/search-result-add-button/index.js
// module id = 1055
// module chunks = 0